import { render, staticRenderFns } from "./ProjectBiometricEdit.vue?vue&type=template&id=fbbf9d12&"
import script from "./ProjectBiometricEdit.vue?vue&type=script&lang=js&"
export * from "./ProjectBiometricEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports